import { createActionGroup, props } from '@ngrx/store';

export const HubspotActions = createActionGroup({
  source: 'Hubspot',
  events: {
    'Create Hubspot Account': props<{ email: string }>(),
    'Set Hubspot Path': props<{ path: string }>(),
  },
});
